
import { urlConstants } from "../constant";
import axios from 'axios';
import { UserObj } from "./localStarage";

export const axiosServices = { postAxios, getAxios, deleteAxios, putAxios, patchAxios };
const apiToken = UserObj ? UserObj.accessToken : '';


function logout() {
    sessionStorage.removeItem("user");
    if (!window.location.pathname.includes("/auth")) {
        setTimeout(() => {
            window.location.href = "/auth/login";
        }, 1200);
    }
}

function postAxios(url, bodyData) {
    return axios.post(urlConstants.BASE_URI_DEV + url, bodyData, { headers: { "Authorization": `Bearer ${apiToken}` } }).then(
        res => { // then print response status
            return res;
            // return handleResponse(res);
        })
        .catch(err => {
            if (err?.response?.data?.message == "User Account Deactivated" || err?.response?.data?.message == "Session expired due to inactivity. Please login again") {
                logout();
            }
            throw err;
        });
}

function patchAxios(url, bodyData) {
    return axios.patch(urlConstants.BASE_URI_DEV + url, bodyData, { headers: { "Authorization": `Bearer ${apiToken}` } }).then(
        res => { // then print response status
            return res;
            // return handleResponse(res);
        })
        .catch(err => {
            if (err?.response?.data?.message == "User Account Deactivated" || err?.response?.data?.message == "Session expired due to inactivity. Please login again") {
                logout();
            }
            throw err;
        });
}

function getAxios(url, bodyData) {
    return axios.get(urlConstants.BASE_URI_DEV + url, { headers: { "Authorization": `Bearer ${apiToken}` } }).then(
        res => { // then print response status
            return res;
        })
        .catch(err => {
            if (err?.response?.data?.message == "User Account Deactivated" || err?.response?.data?.message == "Session expired due to inactivity. Please login again") {
                logout();
            }

            throw err;
        });
}

function deleteAxios(url, bodyData) {
    return axios.delete(urlConstants.BASE_URI_DEV + url, { headers: { "Authorization": `Bearer ${apiToken}` } }).then(
        res => { // then print response status
            return res;
        })
        .catch(err => {
            if (err?.response?.data?.message == "User Account Deactivated" || err?.response?.data?.message == "Session expired due to inactivity. Please login again") {
                logout();
            }
            throw err;
        });
}

function putAxios(url, bodyData) {
    return axios.put(urlConstants.BASE_URI_DEV + url, bodyData, { headers: { "Authorization": `Bearer ${apiToken}` } }).then(
        res => { // then print response status
            return res;
        })
        .catch(err => {
            if (err?.response?.data?.message == "User Account Deactivated" || err?.response?.data?.message == "Session expired due to inactivity. Please login again") {
                logout();
            }
            throw err;
        });
}


// function handleResponse(response) { 
//     if (response.status == 200) {
//         return response.data;
//     } else { 
//         return response.response.data;
//     }
// }